import React from "react";
import _ from "underscore";
import { isNotEmpty } from "../../../framework/utils";
import M from "../../../strings";
import { optional, uuid } from "../../../utils/lang";
import * as ui from "../../utils/ui";

export default class Carousel extends React.Component {
    constructor(props) {
        super(props);
        this.uuid = uuid();
    }

    onLinkClick() {
        const callback = this.props.onLinkClick,
            url = this.props.linkUrl;

        if (callback && _.isFunction(callback)) {
            callback();
        }

        if (url != undefined && url != null) {
            ui.navigate(url);
        }
    }

    render() {
        const className = "carousel" + (isNotEmpty(this.props.className) ? " " + this.props.className : ""),
            items = optional(this.props.items, []),
            title = this.props.title,
            linkLabel = this.props.linkLabel,
            hasHeader = isNotEmpty(title) || isNotEmpty(linkLabel),
            noResultsLabel = this.props.noResultsLabel || M("noResults");

        return (
            <div
                className={className}
            >
                {hasHeader && <div
                    className="carousel__header"
                >
                    <span
                        className="carousel__header-title"
                    >
                        {title}
                    </span>
                    {isNotEmpty(linkLabel) && <div
                        className="carousel__header-link"
                        onClick={this.onLinkClick.bind(this)}
                    >
                        {linkLabel}
                    </div>}
                </div>}
                <div
                    className="carousel__content"
                >
                    {isNotEmpty(items) ? (
                        _.map(items, (item, index) => {
                            const key = "carousel-" + this.uuid + "_item-" + index;
    
                            return (
                                <div
                                    key={key}
                                    className="carousel__item"
                                >
                                    {item}
                                </div>
                            )
                        })
                    ) : (
                        <div
                            className="carousel__item carousel__item--empty"
                        >
                            {noResultsLabel}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}